export default "__VITE_ASSET__De2P6QbK__"